import { getSize, getColor, MathEnabledTextComponent } from '@lib/common';
import { Popover } from 'antd';
import styled from 'styled-components';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useState } from 'react';
import { formatContent } from '../utils';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var QuestionItemContainer = styled.div.withConfig({
  displayName: "question-itemcomponent__QuestionItemContainer",
  componentId: "sc-1885s7k-0"
})(["display:flex;align-items:flex-start;gap:", ";padding:", " ", " ", " ", ";cursor:pointer;border-left:2px solid ", ";border-radius:", ";margin-top:", ";background-color:", ";transition:border-left-color 0.2s ease,background-color 0.2s ease;&:hover{border-left:2px solid ", ";cursor:pointer;background-color:", ";}"], getSize('padding8'), getSize('padding8'), getSize('padding8'), getSize('padding8'), getSize('padding12'), function (_ref) {
  var $active = _ref.$active;
  return $active ? getColor('fillIntActive') : 'transparent';
}, getSize('radiusSm'), getSize('padding4'), function (_ref2) {
  var $active = _ref2.$active;
  return $active ? '#f0f7ff' : 'transparent';
}, getColor('fillIntActive'), function (_ref3) {
  var $active = _ref3.$active;
  return $active ? '#f0f7ff' : '#f8fafc';
});
var StyledQuestionIndex = styled.span.withConfig({
  displayName: "question-itemcomponent__StyledQuestionIndex",
  componentId: "sc-1885s7k-1"
})(["font-weight:600;font-size:", ";color:", ";min-width:24px;flex-shrink:0;padding-top:2px;"], getSize('typo14'), getColor('contentTitle'));
var StyledQuestionText = styled.div.withConfig({
  displayName: "question-itemcomponent__StyledQuestionText",
  componentId: "sc-1885s7k-2"
})(["flex:1;min-width:0;font-size:", ";color:", ";overflow:hidden;"], getSize('typo14'), getColor('contentTitle'));
var StyledExclamationCircleFilled = styled(ExclamationCircleFilled).withConfig({
  displayName: "question-itemcomponent__StyledExclamationCircleFilled",
  componentId: "sc-1885s7k-3"
})(["color:", ";margin-right:", ";"], getColor('fillHighlight1'), getSize('padding12'));
var StyledPointText = styled.span.withConfig({
  displayName: "question-itemcomponent__StyledPointText",
  componentId: "sc-1885s7k-4"
})(["font-size:", ";font-weight:600;color:#94a2b8;"], getSize('typo12'));
var QuestionDescriptionValue = styled(MathEnabledTextComponent).withConfig({
  displayName: "question-itemcomponent__QuestionDescriptionValue",
  componentId: "sc-1885s7k-5"
})(["margin-left:0;color:", ";display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;width:100%;line-height:1.4;"], function (_ref4) {
  var $isQuestionHovered = _ref4.$isQuestionHovered;
  return $isQuestionHovered ? getColor('fillIntActive') : getColor('contentTitle');
}); // Separate component for individual question item to fix hooks rule violation

var QuestionItem = function QuestionItem(_ref5) {
  var question = _ref5.question,
      isActive = _ref5.isActive,
      isQuestionHovered = _ref5.isQuestionHovered,
      hasUnsavedQuestionOrSectionChanges = _ref5.hasUnsavedQuestionOrSectionChanges,
      onSelectQuestion = _ref5.onSelectQuestion,
      onMouseEnter = _ref5.onMouseEnter,
      onMouseLeave = _ref5.onMouseLeave,
      labelTranslation = _ref5.labelTranslation;
  return /*#__PURE__*/_jsx("div", {
    children: !hasUnsavedQuestionOrSectionChanges ? /*#__PURE__*/_jsxs(QuestionItemContainer, {
      $active: isActive,
      onClick: function onClick() {
        return onSelectQuestion(question);
      },
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: [/*#__PURE__*/_jsxs(StyledQuestionIndex, {
        children: [question.titleIndex, "."]
      }), /*#__PURE__*/_jsx(StyledQuestionText, {
        children: /*#__PURE__*/_jsx(QuestionDescriptionValue, {
          value: formatContent(question.description),
          $isQuestionHovered: isQuestionHovered
        })
      }), /*#__PURE__*/_jsxs(StyledPointText, {
        children: [question.score, question.score > 1 ? labelTranslation.pointsShort : labelTranslation.pointShort]
      })]
    }) : /*#__PURE__*/_jsx(Popover, {
      title: "",
      content: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(StyledExclamationCircleFilled, {}), /*#__PURE__*/_jsx("span", {
          children: labelTranslation.questionChangingWarning
        })]
      }),
      trigger: 'hover',
      children: /*#__PURE__*/_jsxs(QuestionItemContainer, {
        $active: isActive,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [/*#__PURE__*/_jsxs(StyledQuestionIndex, {
          children: [question.titleIndex, "."]
        }), /*#__PURE__*/_jsx(StyledQuestionText, {
          children: /*#__PURE__*/_jsx(QuestionDescriptionValue, {
            value: formatContent(question.description),
            $isQuestionHovered: isQuestionHovered
          })
        }), /*#__PURE__*/_jsxs(StyledPointText, {
          children: [question.score, question.score > 1 ? labelTranslation.pointsShort : labelTranslation.pointShort]
        })]
      })
    })
  });
};

export var QuestionItemComponent = function QuestionItemComponent(_ref6) {
  var questions = _ref6.questions,
      hasUnsavedQuestionOrSectionChanges = _ref6.hasUnsavedQuestionOrSectionChanges,
      onSelectQuestion = _ref6.onSelectQuestion,
      labelTranslation = _ref6.labelTranslation,
      selectedFormItemId = _ref6.selectedFormItemId;

  var _useState = useState(null),
      hoveredQuestionId = _useState[0],
      setHoveredQuestionId = _useState[1];

  return /*#__PURE__*/_jsx(_Fragment, {
    children: questions.map(function (question) {
      var questionId = question.id.toString();
      var isActive = selectedFormItemId === questionId;
      var isQuestionHovered = hoveredQuestionId === questionId;
      return /*#__PURE__*/_jsx(QuestionItem, {
        question: question,
        isActive: isActive,
        isQuestionHovered: isQuestionHovered,
        hasUnsavedQuestionOrSectionChanges: hasUnsavedQuestionOrSectionChanges,
        onSelectQuestion: onSelectQuestion,
        onMouseEnter: function onMouseEnter() {
          return setHoveredQuestionId(questionId);
        },
        onMouseLeave: function onMouseLeave() {
          return setHoveredQuestionId(null);
        },
        labelTranslation: labelTranslation
      }, questionId);
    })
  });
};